/* @flow */
import { RECEIVE_FOUNDRY_RESPONSE } from '../actions/foundry_response';
import type { Action } from '../actions/types';
import {get} from 'lodash';

export default (state: TrendingItemsState = {
  stories: {},
  videos: {},
  shops_categories: {}
}, action: Action): TrendingItemsState => {
  switch (action.type) {
    case RECEIVE_FOUNDRY_RESPONSE:
      const trendingItems = action.data.page_data.trending_items;
      if (!trendingItems) {
        return state;
      }

      const modifyTrendingItem = (item: Object): Object => item.object;
      const buildTrendingItems = (items: Object, maxItems: number): Object => {
        return {
          heading: get(items, 'heading', ''),
          path: get(items, 'path', null),
          view_all_heading: get(items, 'view_all_heading', null),
          items: get(items, 'items', []).map(modifyTrendingItem).slice(0, maxItems)
        };
      };

      return {
        stories: buildTrendingItems(trendingItems.stories, 3),
        videos: buildTrendingItems(trendingItems.videos, 3),
        shops_categories: buildTrendingItems(trendingItems.shops_categories, 4)
      };

    default:
      return state;
  }
};

type TrendingItemsState = {
  videos: Object,
  stories: Object,
};
